import request from 'services/request';
import { endpoints } from 'services';
import { paramsToFormData } from 'utils/utils';

export default {
  postLoginIn: (params: LoginInReqDto): Promise<TokenResDto> =>
    request(
      {
        url: endpoints.auth.login,
        method: 'post',
        data: paramsToFormData(params),
      },
      { noAuth: true },
    ),

  postRegister: (params: UserRegisterReqDto): Promise<CommonResDto> =>
    request(
      {
        url: endpoints.auth.register,
        method: 'post',
        data: paramsToFormData(params),
      },
      { noAuth: true },
    ),   
  postActivate: (params: UserActivateReqDto): Promise<CommonResDto> =>
    request(
      {
        url: endpoints.auth.activate,
        method: 'post',
        data: paramsToFormData(params),
      },
      { noAuth: true },
    ),  
  postForgotPassword: (params: UserForgotPasswrodReqDto): Promise<CommonResDto> =>
    request(
      {
        url: endpoints.auth.forgotpassowrd,
        method: 'post',
        data: paramsToFormData(params),
      },
      { noAuth: true },
    ),       
  postResetPassword: (params: UserResetPasswrodReqDto): Promise<CommonResDto> =>
    request(
      {
        url: endpoints.auth.resetpassword,
        method: 'post',
        data: paramsToFormData(params),
      },
      { noAuth: true },
    ),    
};
